<template>
  <div class="footer">
    <div class="homebottom">
      <div align="center" class="bottom">
        <a href="https://www.drcnet.com.cn/statement" target="_blank">网站声明</a>
        |
        <a href="http://company.drcnet.com.cn/lxwm.html#/contact" target="_blank">联系我们</a>
        <!-- |
        <a
          href="javascript:void(0)"
          onclick="SetHome(this,'http://emerging.drcnet.com.cn');"
          >设为首页</a
        > -->
        |
        <a href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx" target="_blank">意见和建议</a>
        |
        <a href="mailto:chiefeditor@drcnet.com.cn" target="_blank">总监信箱</a>
      </div>
      <table cellspacing="8" width="1140" align="center" border="0" style="margin: 0 auto" class="table-m-style">
        <tbody>
          <tr>
            <td colspan="3" align="center" height="60px">
              <p>
                <a href="http://www.drcnet.com.cn" target="_self"><img src="./images/drcnet_h.gif" hspace="4"
                    border="0" /></a>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="bottom" align="middle" width="352" height="50" class="bottom">
              <div class="center-style" align="center">
                Copyright © 1998-{{ newYear }} DRCnet. All Rights Reserved<br />版权所有
                国研网<br />
                <a href="https://beian.miit.gov.cn/" target="_blank" class="ipc">增值电信业务经营许可证
                  京ICP证030059号</a>
                <a href="https://www.drcnet.com.cn/announcement/zizhiimg4" target="_blank"
                  class="ipc">网络出版服务许可证：网出证京字第420号</a>
                <a href="https://www.drcnet.com.cn/announcement/zizhiimg3" target="_blank"
                  class="ipc">出版物经营许可证：新出发京零字第东230083号</a>
                <a href="https://www.drcnet.com.cn/announcement/zizhiimg2" target="_blank" class="ipc">增值电信业务经营许可证
                  京B2-20070136</a>
                <div>建议浏览器：火狐、谷歌</div>

                <!-- <a
                  href="https://www.drcnet.com.cn/announcement/zizhiimg1"
                  style="text-decoration: none"
                  target="_blank"
                  >增值电信业务经营许可证 京ICP证030059号</a
                >&nbsp;&nbsp;
                <a
                  href="https://www.drcnet.com.cn/announcement/zizhiimg2"
                  style="text-decoration: none"
                  target="_blank"
                  >增值电信业务经营许可证 京B2-20070136</a
                >&nbsp;&nbsp;
                <a
                  href="https://www.drcnet.com.cn/announcement/zizhiimg3"
                  style="text-decoration: none"
                  target="_blank"
                  >出版物经营许可证 新出发京批字第直210398号</a
                >&nbsp;&nbsp; -->
                <!-- <div class="footer-bottom">
                  <div class="home">
                    <ul class="bq">
                      <li class="tips"><span class="fl"><a href="https://beian.miit.gov.cn/" target="_blank"
                            class="ipc">增值电信业务经营许可证
                            京ICP证030059号&nbsp;&nbsp;&nbsp;&nbsp;</a></span>
                        <div class="clear"></div>
                      </li>
                      <li class="tips"><span class="fl"><a href="https://www.drcnet.com.cn/announcement/zizhiimg4"
                            target="_blank" class="ipc">网络出版服务许可证：网出证京字第420号&nbsp;&nbsp;&nbsp;&nbsp;</a></span>
                        <div class="clear"></div>
                      </li>
                      <li class="tips"><span class="fl"><a href="https://www.drcnet.com.cn/announcement/zizhiimg3"
                            target="_blank" class="ipc">出版物经营许可证：新出发京零字第东230083号&nbsp;&nbsp;&nbsp;&nbsp;</a></span>
                        <div class="clear"></div>
                      </li>
                      <li class="tips" style="float: right;"><span>建议浏览器：火狐、谷歌</span>
                        <div class="clear"></div>
                      </li>
                    </ul>
                    <ul class="bq">
                      <li class="tips"><span class="fl"><a href="https://www.drcnet.com.cn/announcement/zizhiimg2"
                            target="_blank" class="ipc">增值电信业务经营许可证 京B2-20070136&nbsp;&nbsp;&nbsp;&nbsp;</a></span>
                        <div class="clear"></div>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                </div> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="width: 210px; margin: 0 auto; padding: 20px 0" class="bottom-content">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002958" style="
            background: url(http://images.drcnet-sod.com/images/common/beian.png)
              no-repeat left center;
            display: inline-block;
            text-decoration: none;
            background-repeat: no-repeat;
          ">
          <p style="
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 25px;
              color: #939393;
              font-size: 12px;
            ">
            京公网安备 11010102002958号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      newYear: new Date().getFullYear(),
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  background: url(./images/footerbj.png) no-repeat;
  padding: 30px;
  margin-top: 30px;
  background-position: center;
  line-height: 119%;

  .homebottom {
    width: 1140px;
    padding-top: 20px;
    margin: auto;
    color: #333;
    font-size: 12px;

    .bottom {
      a {
        color: #333;
        font-size: 13px;

      }

      .ipc {
        text-decoration: none;
        &:not(:last-child){
          margin-right: 12px;
        }
      }
    }

    td {
      a {
        text-decoration: underline;
        font-size: 12px;
      }
    }

    .bottom-content {
      a {
        color: #333;
        font-size: 13px;
      }
    }
  }
  .center-style{
    line-height: 180%;
  }

}

@media screen and (max-width: 769px) {

  .homebottom,
  .table-m-style {
    width: 100% !important;
  }
}
</style>